import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const RefreshIcon = ({ className, fill = 'currentColor', ...props }: React.ComponentProps<'svg'>) => (
    <svg
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={mergeClassNames('w-[18px] h-[18px]', className)}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3334 1.49969C18.7937 1.49969 19.1668 1.87278 19.1668 2.33302V7.33302C19.1668 7.79326 18.7937 8.16635 18.3334 8.16635H13.3334C12.8732 8.16635 12.5001 7.79326 12.5001 7.33302C12.5001 6.87278 12.8732 6.49969 13.3334 6.49969H17.5001V2.33302C17.5001 1.87278 17.8732 1.49969 18.3334 1.49969Z"
            fill={fill} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1064 2.40071C8.67524 2.19772 7.2169 2.46536 5.95111 3.1633C4.68532 3.86125 3.68066 4.95168 3.08852 6.27029C2.49639 7.58889 2.34885 9.06423 2.66816 10.474C2.98746 11.8837 3.7563 13.1515 4.85881 14.0863C5.96133 15.0211 7.3378 15.5722 8.78079 15.6566C10.2238 15.741 11.6551 15.3542 12.8591 14.5543C14.0631 13.7545 14.9745 12.585 15.456 11.2221C15.6093 10.7881 16.0854 10.5606 16.5194 10.7139C16.9533 10.8673 17.1808 11.3433 17.0275 11.7773C16.4256 13.4809 15.2864 14.9428 13.7814 15.9426C12.2764 16.9424 10.4872 17.4259 8.68345 17.3204C6.87972 17.2149 5.15913 16.526 3.78099 15.3575C2.40284 14.1891 1.44179 12.6043 1.04266 10.8421C0.643533 9.07996 0.82795 7.23579 1.56812 5.58753C2.30829 3.93927 3.56412 2.57623 5.14635 1.7038C6.72859 0.831372 8.55152 0.496822 10.3404 0.750565C12.1251 1.0037 13.7794 1.82864 15.0554 3.10147L18.9047 6.72634C19.2398 7.04186 19.2556 7.56926 18.9401 7.90432C18.6246 8.23938 18.0972 8.25522 17.7621 7.9397L13.9038 4.30637C13.8977 4.30059 13.8916 4.29472 13.8857 4.28876C12.8639 3.26634 11.5375 2.60371 10.1064 2.40071Z"
            fill={fill} />

    </svg>
);

export default RefreshIcon;